<!-- 诊疗首页 -->
<template>
  <div>
    <div class="head">
      <!-- 首页轮播 -->
      <div class="swipe">
        <van-swipe :autoplay="3000" lazy-render height="260">
          <van-swipe-item>
            <van-image :src="syztImg" class="swipe-img" fit="cover"/>
          </van-swipe-item>
        </van-swipe>
      </div>
      <!-- 快捷入口-->
      <div class="kuaij">
        <van-row style="padding: 10px 10px;text-align: center;" type="flex" justify="space-around" gutter="5">
          <van-col span="6" @click="toUrl(item.url)" v-for="(item, index) in node1.children" :key="index">
            <div class="kuaij-image-div">
              <van-image class="size" :src="img_Prefix + item.imageName"/>
            </div>
            <div style="padding-top: 10px;font-size: 14px;">{{ item.name }}</div>
          </van-col>
        </van-row>
      </div>
    </div>
    <!-- 门诊服务 -->
    <div class="modular-bg">
      <van-row align="left">
        <van-col span="1">
          <div class="menz-select"></div>
        </van-col>
        <van-col span="23">
          <div class="modular-title">{{ node2.name }}</div>
        </van-col>
      </van-row>
      <van-row class="modular-content" type="flex">
        <van-col style="width:25%;padding-bottom: 10px;" @click="toUrl(item.url)"
                 v-for="(item, index) in node2.children" :key="index">
          <van-image class="modular-img-size" :src="img_Prefix + item.imageName" width="35" height="35"/>
          <div class="modular-img-title">{{ item.name }}</div>
        </van-col>
      </van-row>
    </div>
    <!-- 住院服务 -->
    <div>
      <van-row style="margin: 10px 4%;" type="flex" justify="space-around" gutter="15">
        <van-col span="12" @click="toUrl(item.url)" v-for="(item, index) in node3.children" :key="index">
          <div class="zhuy-img-bg">
            <div class="zhuy-image-div">
              <van-image width="40" height="40" :src="img_Prefix + item.imageName"/>
            </div>
            <ul>
              <li class="zhuy-img-title"><strong>{{ item.name }}</strong></li>
              <!-- <li class="zhuy-img-title2"><strong style="font-size: 12px;color: #CCCCCC;">{{ item.desp }}</strong></li> -->
            </ul>
          </div>
        </van-col>
      </van-row>
    </div>
    <!-- 其它服务 -->
    <div class="modular-bg">
      <van-row align="left">
        <van-col span="1">
          <div class="menz-select"></div>
        </van-col>
        <van-col span="23">
          <div class="modular-title">{{ node4.name }}</div>
        </van-col>
      </van-row>
      <van-row class="modular-content" type="flex">
        <van-col style="width:25%;padding-bottom: 10px;" v-for="(item, index) in node4.children" :key="index">
          <div v-if="item.name == '医院导航'" @click="toAddress">
            <van-image class="modular-img-size" :src="img_Prefix + item.imageName" width="35" height="35"/>
            <div class="modular-img-title">{{ item.name }}</div>
          </div>
          <div v-if="item.name != '医院导航'" @click="toUrl(item.url)">
            <van-image class="modular-img-size" :src="img_Prefix + item.imageName" width="35" height="35"/>
            <div class="modular-img-title">{{ item.name }}</div>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import {getTreeNodeList} from '@/api/nodeenter';

export default {
  inject: ["reload"],
  name: 'index',
  data() {
    return {
      syztImg: require('@assets/images/zhut2.jpg'),
      gaode: process.env.VUE_APP_GAODE_PREFIX, //高德地图请求的前缀
      img_Prefix: process.env.VUE_APP_IMG_BASEURL, //线上图片的前缀
      node1: [], //快捷入口
      node2: [], //门诊服务
      node3: [], //住院服务
      node4: [], //其它服务
    };
  },
  created() {
    //初始化功能节点
    getTreeNodeList().then(res => {
      if (res.success) {
        this.node1 = res.result[0];
        this.node2 = res.result[1];
        this.node3 = res.result[2];
        this.node4 = res.result[3];
      }
    }).catch(() => {
      //直接使用
      this.reload()
    })
  },
  methods: {
    // 来院导航
    toAddress() {
      location.href = this.gaode;
    },
    toUrl(url) {
      if (url.indexOf("http") != -1) {
      	location.href = url;
      } else {
      	this.$router.push({ path: url });
      }
    }
  }
};
</script>

<style scoped="scoped">
.swipe {
  background-color: gary;
}

.swipe .swipe-img {
  width: 100%;
  height: 100%;
  margin-top: -60px;
}

.head {
  height: 295px;
}

.head .search {
  background-color: #0ec9ac;
  height: 100px;
}

.kuaij {
  background-color: #ffffff;
  position: absolute;
  top: 170px;
  width: 92%;
  left: 4%;
  border-radius: 10px;
}

.kuaij .kuaij-image-div {
  width: 60px;
  height: 60px;
  border: 1px solid #fafafa;
  border-radius: 35px;
  background-color: #f2f3f5;
  line-height: 90px;
  display: inline-block;
  text-align: center;
  background-image: -moz-linear-gradient(top, #fdfdfd, #ebedf0);
  /* Firefox */
  background-image: -webkit-gradient(linear, left top, left bottom, color-stop(0, #fdfdfd), color-stop(1, #ebedf0));
  /* Saf4+, Chrome */
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#fdfdfd', endColorstr='#ebedf0', GradientType='0');
  /* IE*/
}

.kuaij .kuaij-image-div .size {
  width: 40px;
  height: 40px;
}

.modular-bg {
  background-color: #ffffff;
  border-radius: 10px;
  width: 92%;
  margin-left: 4%;
}

.modular-title {
  font-size: 17px;
  margin: 5px;
}

.modular-content {
  padding: 10px 3px;
  text-align: center;
}

.modular-img-size {
  width: 30px;
  height: 30px;
}

.modular-img-title {
  padding-top: 8px;
  font-size: 13px;
}

.zhuy-image-div {
  width: 65px;
  height: 65px;
  border-radius: 35px;
  background-color: #f2f3f5;
  line-height: 100px;
  display: inline-block;
  text-align: center;
  margin-left: 4px;
  margin-top: 8px;
}

.zhuy-img-bg {
  background-color: #ffffff;
  height: 80px;
  border-radius: 8px;
  display: flex;
}

.zhuy-img-title {
  padding:30px 0px 0px 8px;
}

.zhuy-img-title2 {
  padding: 5px 0px 0px 8px;
}

.menz .menz-col {
  padding-left: 5px;
}

.menz-select {
  margin-top: 7px;
  margin-left: 10px;
  width: 5px;
  height: 20px;
  background-color: #0ec9ac;
}
</style>
